/* eslint-disable import/prefer-default-export */
// note this doesn't do anything about escaping double quotes
export const toCsvString = (data = [[]]) =>
  data
    .map(row =>
      row.map(cell => (String(cell).match(/[,\s]/) ? `"${cell}"` : cell)).join(',')
    )
    .join('\n');
